
import { createApp } from "vue";

const app = createApp({
  // root instance definition
});


export default app
